/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateBasicInformationSupportRequestWheelChair } from './updateBasicInformationSupportRequestWheelChair';

/**
 * 予約基本情報(サポート情報)登録APIリクエストデータ型
 */
export interface UpdateBasicInformationSupportRequest {
  /**
   * 歩行の程度<br/> WCHR：「階段の昇り降りはできるが、長距離の歩行はできない」<br/> WCHS：「機内の移動はできるが、階段の昇り降りはできない」<br/> WCHC：「歩行ができない(機内の座席近くまで車いすを利用し、移乗の介助が必要)」<br/>
   */
  degreeSpecialServiceRequest?: UpdateBasicInformationSupportRequest.DegreeSpecialServiceRequestEnum | null;
  wheelChair?: UpdateBasicInformationSupportRequestWheelChair;
  /**
   * 視覚障がい有無<br/> BLND：有<br/> \"\"(空文字列)：無
   */
  blind?: UpdateBasicInformationSupportRequest.BlindEnum | null;
  /**
   * 聴覚障がい有無<br/> DEAF：有<br/> \"\"(空文字列)：無
   */
  deaf?: UpdateBasicInformationSupportRequest.DeafEnum | null;
}
export namespace UpdateBasicInformationSupportRequest {
  export type DegreeSpecialServiceRequestEnum = 'WCHR' | 'WCHS' | 'WCHC';
  export const DegreeSpecialServiceRequestEnum = {
    Wchr: 'WCHR' as DegreeSpecialServiceRequestEnum,
    Wchs: 'WCHS' as DegreeSpecialServiceRequestEnum,
    Wchc: 'WCHC' as DegreeSpecialServiceRequestEnum,
  };
  export type BlindEnum = 'BLND' | '';
  export const BlindEnum = {
    Blnd: 'BLND' as BlindEnum,
    Empty: '' as BlindEnum,
  };
  export type DeafEnum = 'DEAF' | '';
  export const DeafEnum = {
    Deaf: 'DEAF' as DeafEnum,
    Empty: '' as DeafEnum,
  };
}
